import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  makeStyles,
  Button,
  Grid,
  Dialog,
  DialogContent,
} from "@material-ui/core";

import { workingNetwork } from "src/hooks/address";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import Card from "./Card";
import {
  connectToWallet,
  sortAddress,
  checkMetaMask,
  getData,
  canDefrostStaking,
  monthlyTranche,
  monthCount,
  defrostToken,
} from "src/hooks/operations";
const useStyle = makeStyles((theme) => ({
  root: {
    background: theme.palette.primary.main,
  },
  logo: {
    width: 80,
    height: 80,
    background: "#ffffff",
    borderRadius: "50%",
  },
  iconBox: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff",
  },
  green: {
    color: theme.palette.success.main,
  },
}));

export default function Home({ userData, ownerId, refresh, allData }) {
  const classes = useStyle();
  const { account, chainId } = userData;
  const [open, setOpen] = useState(false);
  const [otherNetwork, setOtherNetwork] = useState(false);
  const [tileData, setTileData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [stopDefrost, setStopDefrost] = useState(false);
  const [canDefrostStakingStatus, setCanDefrostStakingStatus] = useState({
    clicked: false,
    status: false,
  });
  const [monthlyTrancheStatus, setMonthlyTrancheStatus] = useState({
    clicked: false,
    status: false,
  });
  const [monthCountStatus, setMonthCountStatus] = useState({
    clicked: false,
    status: false,
  });

  const isMetaMask = checkMetaMask();

  const connect = async () => {
    if (!isMetaMask) {
      setOpen(true);
    } else {
      const res = await connectToWallet();
      if (res === "connected") {
        window.location.reload();
      }
    }
  };
  useEffect(() => {
    if (chainId !== null && workingNetwork !== chainId) {
      setOtherNetwork(true);
    } else {
      setOtherNetwork(false);
    }
  }, [chainId]);

  useEffect(() => {
    const getdata = async () => {
      setIsLoading(true);
      const data = await getData(account);
      setTileData(data);
      allData(data);
      setIsLoading(false);
    };
    if (account && workingNetwork === chainId) {
      getdata();
    }
  }, [account, chainId, refresh]);

  const on_canDefrostStaking = async () => {
    const status = await canDefrostStaking();
    setCanDefrostStakingStatus({
      clicked: true,
      status: status,
    });
  };
  const on_monthlyTranche = async () => {
    const status = await monthlyTranche();
    setMonthlyTrancheStatus({
      clicked: true,
      status: status,
    });
  };
  const on_monthCount = async () => {
    const status = await monthCount();
    setMonthCountStatus({
      clicked: true,
      status: status,
    });
  };
  const on_defrostToken = async () => {
    const status = await defrostToken();
    if (!status) {
      setStopDefrost(true);
    }
  };
  return (
    <Box className={classes.root} pt={3} pb={16}>
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="space-between" mb={6}>
          <Box className={classes.logo}>
            <img src="images/logo.png" alt="logo" width="100%" />
          </Box>
          <Box display="flex" alignItems="center">
            {account ? (
              <Typography variant="h5" style={{ color: "#ffffff" }}>
                {sortAddress(account)}
              </Typography>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={connect}
              >
                Connect
              </Button>
            )}
          </Box>
        </Box>
        <Grid container spacing={3}>
          {account && account.toUpperCase() === ownerId.toUpperCase() && (
            <>
              <Grid item xs={12} sm={6} lg={3}>
                <Button
                  variant="contained"
                  color="default"
                  size="large"
                  fullWidth
                  onClick={on_canDefrostStaking}
                >
                  Can Defrost Staking &nbsp;
                  {canDefrostStakingStatus.clicked &&
                    canDefrostStakingStatus.status && (
                      <CheckCircleIcon color="primary" />
                    )}
                  {canDefrostStakingStatus.clicked &&
                    !canDefrostStakingStatus.status && (
                      <CancelIcon color="secondary" />
                    )}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <Button
                  variant="contained"
                  color="default"
                  size="large"
                  fullWidth
                  onClick={on_monthlyTranche}
                  style={{ padding: 14 }}
                >
                  Can unlock monthly tranche &nbsp;
                  {monthlyTrancheStatus.clicked &&
                    monthlyTrancheStatus.status && (
                      <CheckCircleIcon color="primary" />
                    )}
                  {monthlyTrancheStatus.clicked &&
                    !monthlyTrancheStatus.status && (
                      <CancelIcon color="secondary" />
                    )}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <Button
                  variant="contained"
                  color="default"
                  size="large"
                  fullWidth
                  onClick={on_monthCount}
                >
                  month count &nbsp;
                  {monthCountStatus.clicked && monthCountStatus.status && (
                    <span>({monthCountStatus.status})</span>
                  )}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <Button
                  variant="contained"
                  color="default"
                  size="large"
                  fullWidth
                  onClick={on_defrostToken}
                >
                  Defrost token
                </Button>
              </Grid>
            </>
          )}

          <Card
            isLoading={isLoading}
            title="Max Tokens"
            value={tileData && tileData.MAX_NUM_TESTTOKENS}
          />
          <Card
            isLoading={isLoading}
            title="Wallet Balance"
            value={tileData && tileData.unlockedBalanceOf}
          />

          {account && account.toUpperCase() !== ownerId.toUpperCase() ? (
            <>
              <Card
                isLoading={isLoading}
                title="Total Balance"
                value={tileData && tileData.totalBalance}
              />
              <Card
                isLoading={isLoading}
                title="Total Stake Balance"
                value={tileData && tileData.totalStake}
              />
              <Card
                isLoading={isLoading}
                title="Current Tier"
                value={tileData && tileData.tierName}
                name
              />
              <Card
                isLoading={isLoading}
                title="Current Tier Value"
                value={tileData && tileData.tierBalance}
              />
            </>
          ) : (
            <>
              <Card
                isLoading={isLoading}
                title="Total Supply"
                value={tileData && tileData.totalSupply}
              />
              <Card
                isLoading={isLoading}
                title="Strategic Sale Balance"
                value={tileData && tileData.totalStrategicSupply}
              />
              <Card
                isLoading={isLoading}
                title="Private Sale 1 Balance"
                value={tileData && tileData.totalPvt1Supply}
              />
              <Card
                isLoading={isLoading}
                title="Private Sale 2 Balance"
                value={tileData && tileData.totalPvt2Supply}
              />
              <Card
                isLoading={isLoading}
                title="Total AirDrop"
                value={tileData && tileData.totalAirdropSupply}
              />
            </>
          )}
        </Grid>
      </Container>
      {open && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Box textAlign="center" p={2}>
              <img
                src="images/metamask-fox.svg"
                width="50"
                alt=""
                className="m-r-10"
              />
              <Typography>Please Install MetaMask</Typography>
            </Box>
          </DialogContent>
        </Dialog>
      )}
      {otherNetwork && (
        <Dialog
          open={otherNetwork}
          onClose={() => setOtherNetwork(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Box textAlign="center" p={2} pt={1}>
              <Typography>Please change your network to Rinkeby</Typography>
            </Box>
          </DialogContent>
        </Dialog>
      )}
      {stopDefrost && (
        <Dialog
          open={stopDefrost}
          onClose={() => setStopDefrost(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Box textAlign="center" p={2} pt={1}>
              <Typography>Sorry, stake time not over yet!</Typography>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}
